import { Button, Card, CardContent } from "@repo/ui";

export function Home() {
  return (
    <div className="relative min-h-[70vh] flex items-center justify-center">
      <div className="absolute inset-0 bg-gradient-to-b from-gray-50 to-white" aria-hidden="true" />
      <div className="relative container mx-auto px-6">
        <Card className="mx-auto max-w-3xl border-muted/60">
          <CardContent className="py-20 text-center">
            <img
              src="https://storage.stardeck.ai/images/58011507-e668-4a15-a86b-666ba8ba6008.png"
              alt="Product dashboard and analytics UI mockup"
              className="mx-auto mb-8 w-full max-w-2xl rounded-xl border border-muted/60"
              loading="eager"
              decoding="async"
            />
            <h1 className="text-5xl md:text-7xl font-semibold tracking-tight bg-clip-text text-transparent bg-gradient-to-b from-neutral-900 to-neutral-600">
              Hello from stardeck
            </h1>
            <div className="mt-6 flex justify-center">
              <Button className="bg-[var(--magenta-600)] hover:bg-[var(--magenta-700)] text-white">
                whats up?
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
